import {
  Box,
  Button,
  Chip,
  Paper,
  Tab,
  Tabs,
  Typography,
  styled,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { buildAccessChipVariants } from './accessChipColors';

export const Layout = styled(Box)(({ theme }) => ({
  alignItems: 'flex-start',
  display: 'flex',
  gap: 48,
  width: '100%',
  marginTop: theme.spacing(2.5),
}));

export const InfoColumn = styled(Box)({
  flex: '0 0 320px',
  maxWidth: 360,
});

export const RolesColumn = styled(Box)({
  flex: 1,
  minWidth: 0,
});

export const BackButtonWrap = styled(Box)({});

export const BackButton = styled(Button)({
  fontWeight: 700,
  paddingLeft: 0,
  textTransform: 'none',
});

export const AccessActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2.5),
  justifyContent: 'flex-start',
  marginTop: theme.spacing(2.5),
}));

export const BreadcrumbLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const BreadcrumbsWrap = styled(Box)({
  marginBottom: 40,
});

export const SectionTitle = styled(Typography)({
  fontWeight: 700,
  marginBottom: 24,
});

export const RolesCard = styled(Paper)(({ theme }) => ({
  border: `1px solid ${theme.palette.border}`,
  borderRadius: 12,
  boxShadow: 'none',
  padding: 24,
}));

export const TabsRow = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  gap: 8,
}));

export const RoleTabs = styled(Tabs)(({ theme }) => ({
  flex: '0 1 auto',
  maxWidth: 'calc(100% - 140px)',
  minHeight: 40,
  minWidth: 0,
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
  },
  '& .MuiTabs-scrollButtons': {
    display: 'none',
  },
}));

export const RoleTab = styled(Tab)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 14,
  fontWeight: 700,
  minHeight: 40,
  minWidth: 0,
  padding: '12px 16px',
  textTransform: 'uppercase',
  '&.Mui-selected': {
    color: theme.palette.primary.main,
  },
}));

export const AddRoleButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.main,
  flexShrink: 0,
  fontSize: 14,
  fontWeight: 700,
  minHeight: 40,
  padding: '12px 16px',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
}));

export const TabContentHeader = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 24,
  marginTop: 24,
});

export const PermissionsTitle = styled(Typography)({
  fontWeight: 700,
});

export const RemoveRoleButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
  borderRadius: 20,
  color: theme.palette.common.white,
  flexShrink: 0,
  fontSize: 12,
  fontWeight: 700,
  padding: '6px 16px',
  textTransform: 'uppercase',
  '&:hover': {
    backgroundColor: theme.palette.error.dark,
  },
}));

export const EmptyRolesWrap = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  justifyContent: 'center',
  minHeight: 280,
  padding: 24,
  textAlign: 'center',
});

export const EmptyRolesText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 16,
  lineHeight: '24px',
  maxWidth: 400,
}));

export const PermissionListBox = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.border}`,
  borderRadius: 8,
  display: 'grid',
  gridTemplateColumns: 'max-content minmax(0, 1fr) max-content',
  overflow: 'hidden',
}));

export const PermissionRow = styled(Box)(({ theme }) => ({
  alignItems: 'flex-start',
  columnGap: 24,
  display: 'grid',
  gridColumn: '1 / -1',
  gridTemplateColumns: 'subgrid',
  padding: '16px 20px',
  '&:not(:last-child)': {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));

export const PermissionName = styled(Typography)({
  fontSize: 14,
  fontWeight: 700,
  lineHeight: '22px',
  whiteSpace: 'nowrap',
});

export const PermissionDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 14,
  lineHeight: '22px',
  minWidth: 0,
}));

export const AccessChip = styled(Chip)(({ theme }) => ({
  alignSelf: 'start',
  borderRadius: 12,
  flexShrink: 0,
  fontSize: 11,
  fontWeight: 700,
  height: 24,
  margin: 0,
  whiteSpace: 'nowrap',
  '& .MuiChip-label': {
    fontSize: 11,
    fontWeight: 700,
    overflow: 'visible',
    paddingLeft: 10,
    paddingRight: 10,
    textOverflow: 'clip',
    whiteSpace: 'nowrap',
  },
  ...buildAccessChipVariants(theme),
}));
